// @ts-nocheck
import React, { useMemo, useRef } from "react";
import { Auth0Provider } from "@auth0/auth0-react";

import { redirectUri } from "../constants";
import { trackEvent } from "@/analytics";
import { AUTH_EVENTS } from "@/analytics/events";

export const Auth0ProviderWithHistory: React.FC<{}> = ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const scope = "openid profile email read:positions";

  const hasRedirectedRef = useRef(false);

  const onRedirectCallback = (appState) => {
    console.log("[oauth] onRedirectCallback called with appState:", appState);

    // Only
    // redirect once - prevent double redirect when callback is called multiple times
    if (hasRedirectedRef.current) {
      console.log("[oauth] already redirected, skipping second callback");
      return;
    }

    // Track successful login
    trackEvent(AUTH_EVENTS.LOGIN_SUCCEEDED, {
      auth_method: "auth0",
      entry_point: appState?.targetUrl ? "app_redirect" : "landing_page",
    });

    const targetUrl =
      appState?.targetUrl || appState?.returnTo || window.location.pathname;
    console.log("[oauth] navigating to targetUrl:", targetUrl);

    hasRedirectedRef.current = true;
    // This provider sits above every <Router> (index.js), so useHistory() here was
    // undefined and history.push threw: Auth0 caught it as a login error, left the
    // user logged out with ?code&state still in the URL, and App sent them straight
    // back to Auth0 — the iPhone Safari signup loop of 2026-10-06. replaceState is
    // safe because App mounts its Router only after Auth0 stops loading, so it
    // reads this URL fresh; it also drops code/state from back-button history.
    window.history.replaceState({}, document.title, targetUrl);
  };

  // check if running in cypress and set localstorage or memory
  let cache;
  // @ts-ignore
  if (window.Cypress) {
    cache = "localstorage";
  } else if (process.env.REACT_APP_ENV === "dev") {
    cache = "localstorage"; // Use localstorage in dev for session persistence
  } else {
    // Production: use localStorage to persist tokens across navigation (history.push)
    // Memory cache is cleared when page navigation occurs
    cache = "localstorage";
  }
  // console.log("redirectUri", window.location.origin);
  console.log("port", window.location.port);

  const redirectUri = useMemo(() => {
    // console.log(
    //   "[oauth] calling redirect uri",
    //   JSON.stringify(window.location)
    // );
    if (process.env.REACT_APP_ENV === "dev") {
      return `${window.location.origin}`;
    } else {
      // prod
      if (typeof window.gtag === "function") {
        window.gtag("event", "login", {});
      }
      // track google event
      return `${window.location.origin}/`;
    }
  }, []);

  // Landing CTAs send ?screen_hint=signup. Read once at mount and set on the provider, so every
  // loginWithRedirect (ProtectedRoute, login_required, 401 handler) opens Auth0 signup, not login.
  const screenHint = useMemo(
    () => (new URLSearchParams(window.location.search).get("screen_hint") === "signup" ? "signup" : undefined),
    []
  );

  return (
    // @ts-ignore
    <Auth0Provider
      domain={domain ?? "moonscape.app"}
      clientId={clientId}
      audience={audience}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        scope: "openid profile email",
        screen_hint: screenHint,
      }}
      /** By default, if the page url has code/state params, the SDK will treat them as Auth0's and attempt to exchange the code for a token. In some cases the code might be for something else (another OAuth SDK perhaps). In these instances you can instruct the client to ignore them eg

 */
      skipRedirectCallback={window.location.pathname === "/coinbase-auth"}
      onRedirectCallback={onRedirectCallback}
      cacheLocation={cache}
      // Rotating refresh tokens = long-lived sessions without re-login.
      // Without this, silent renewal needs a hidden iframe + third-party
      // cookies, which browsers block — so sessions died with the access token.
      useRefreshTokens
      useRefreshTokensFallback
    >
      {children}
    </Auth0Provider>
  );
};
